import React from 'react';
import AboutUSPageLayout from '../components/about-us/aboutUSPageLayout/about-us-page-layout';

class AboutUSPage extends React.Component {
	render() {
		return <AboutUSPageLayout></AboutUSPageLayout>;
	}
}

export default AboutUSPage;